import { Box, Container, Typography } from "@mui/material";
import React from "react";

const PageNotFound: React.FC = () => {
  return (
    <Box>
      <Container sx={{ mt: 5 }}>
        <Typography variant="h1" align="center">
          404
        </Typography>
        <Typography variant="h3" align="center">
          Page not found!
        </Typography>
      </Container>
    </Box>
  );
};

export default PageNotFound;
